export enum DcFields {
    DcId = 'dcid',
    DcCode = 'dccode',
    DcName = 'dcname',
    GrnNumber = 'grnnumber',
    PoNumber = 'ponumber',
    WarehouseAlignmentCode = 'warehousealignmencode',
    WarehouseArea = 'warehousearea',
    WarehouseRotation = 'warehouserotation',
    WmSystem = 'wmsystem',
    EmailID = 'emailid',
    Address = 'address',
    MainPhone = 'mainphone',
    ContactNumber = 'contactnumber',
    ManagerNumber = 'managernumber',
    ManagerContact = 'managercontact',
    City = 'city',
    StateProvinceRegion = 'stateprovinceregion',
    PostalCode = 'postalcode',
    Country = 'country',
    StorageCapacityInSqft = 'storagecapacityinsqft',
    OperatingHours = 'operatinghours',
    ShippingMethods = 'shippingmethods',
    ReceivingHours = 'receivinghours',
    ManagerName = 'managername',
    StorageCapacity = 'storagcapacity',
    NumberOfDocks = 'numberofdocks',
    FacilitySize = 'facilitysize',
    AutomationLevel = 'automationlevel',
    EnergyManagement = 'energymanagement',
    ZoneDetails = 'zonedetails',
    LoadingDockInfo = 'loadingdockinfo',
    SafetyEquipment = 'safetyequipment',
    ComplianceCertifications = 'compliancecertifications',
    MaterialHandlingEquipment = 'materialhandlingequipment',
    TechnologyInfrastructure = 'technologyinfrastructure',
    MaintenanceSchedule = 'maintenanceschedule',
    InventoryAccuracyRate = 'inventoryaccuracyrate',
    InventoryTypes = 'inventorytypes',
    ProductCategory = 'productcategory',
    SpecializedStorageAreas = 'specializedstorageAreas',
    KeyShippingRoutes = 'keyshippingroutes',
    PreferredCarriers = 'preferredcarriers',
    ShippingFrequency = 'shippingfrequency',
    LeadTime = 'leadtime',
    SkusManaged = 'skusmanaged',
    AllowedTimeInWarehouseDays = 'allowedtimeinwarehousedays',
}

export enum DcTabs{
    LogisticsAndInventory = 'Logistics And Inventory',
    CapacityAndOperations = 'Capacity And Operations',
    GeneralInformation = 'General Information'
}